// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "small[data-v-38dfa1ce]{display:block;font-size:smaller}", ""]);
// Exports
module.exports = exports;
